import { NgModule } from '@angular/core';
import { CFormDynamiqueAllFieldsComponent } from './c-form-dynamique-all-fields.component';
import { CLabelModule } from '../c-label/c-label.module';
import { CFieldStatusModule } from '../c-fields/c-field-status/c-field-status.module';
import { CCheckboxLabelHtmlModule } from '../c-fields/c-checkbox-label-html/c-checkbox-label-html.module';
import { CCheckboxModule } from '../c-fields/c-checkbox/c-checkbox.module';
import { CRadioLabelHtmlModule } from '../c-fields/c-radio-label-html/c-radio-label-html.module';
import { CRadioModule } from '../c-fields/c-radio/c-radio.module';
import { CTextareaModule } from '../c-fields/c-textarea/c-textarea.module';
import { CInputtextModule } from '../c-fields/c-inputtext/c-inputtext.module';
import { CDrawingModule } from '../c-fields/c-drawing/c-drawing.module';
import { AsyncLabelModule } from 'src/app/pipes/async-label/async-label.module';
import { CListeModule } from '../c-fields/c-liste/c-liste.module';
import { CCasesDynamiquesEditionModule } from '../c-fields/c-cases-dynamiques/c-cases-dynamiques-edition/c-cases-dynamiques-edition.module';
import { CCasesDynamiquesPreparationModule } from '../c-fields/c-cases-dynamiques/c-cases-dynamiques-preparation/c-cases-dynamiques-preparation.module';
import { AsPipesModule } from 'src/app/pipes/as-pipes/as-pipes.module';
import { CommonModule } from '@angular/common';
import { GetFieldInFormModule } from 'src/app/pipes/get-field-in-form/get-field-in-form.module';
import { AsInstanceOfFormElementModule } from 'src/app/pipes/as-instance-of-form-element/as-instance-of-form-element.module';
import { CTooltipButtonModule } from '../c-tooltip-button/c-tooltip-button.module';


@NgModule({
    declarations: [CFormDynamiqueAllFieldsComponent],
    imports: [
      CommonModule,
  
      CLabelModule,
      CFieldStatusModule,
      CCheckboxLabelHtmlModule,
      CCheckboxModule,
      CRadioLabelHtmlModule,
      CRadioModule,
      CTextareaModule,
      CInputtextModule,
      CDrawingModule,
      CListeModule,
      CCasesDynamiquesEditionModule,
      CCasesDynamiquesPreparationModule,
      CTooltipButtonModule,
      
      // pipes
      AsInstanceOfFormElementModule,
      AsyncLabelModule,
      AsPipesModule,
      GetFieldInFormModule,
  
  
    ],
    exports: [CFormDynamiqueAllFieldsComponent]
})
export class CFormDynamiqueAllFieldsModule { }
